import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { showNotification } from "Common/utils/Notification";
import BreadCrumb from "Common/BreadCrumb";
import { CONTENT_ADD_ROUTE, CONTENT_LIST_ROUTE } from "constants/routeEnum";
import { ToastContainer } from "react-toastify";
import LoaderComponent from "Common/Components/Loader/Loader";

const AddContent = () => {
  const navigate = useNavigate();
  const [buttons, setButtons] = useState<any>([]);
  const [loader, setLoader] = useState<any>(false);
  const [headerText, setHeaderText] = useState<any>();

  const [errors, setErrors] = useState<any>({
    banner_header_text: "",

    buttons: buttons?.map(() => ({ label: "", value: "" })),
  });

  const addButton = () => {
    setButtons([...buttons, { label: "", value: "" }]);
    let newErrors = { ...errors };
    newErrors.buttons.push({ label: "", value: "" });
    setErrors(newErrors);
  };

  const removeButton = (index) => {
    const updatedButtons = buttons.filter((_, i) => i !== index);
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    updatedErrors.buttons.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleInputChange = (index, field, value) => {
    const updatedButtons = buttons.map((button, i) => {
      if (i === index) {
        button[field] = value;
      }
      return button;
    });
    setButtons(updatedButtons);

    const updatedErrors = { ...errors };
    if (updatedErrors.buttons[index]) {
      updatedErrors.buttons[index][field] = "";
    }
    setErrors(updatedErrors);
  };

  const handleSave = async () => {
    const newErrors = {
      banner_header_text:
        headerText.trim() === "" ? "Please enter a banner header." : "",

      buttons: buttons?.map(() => ({ label: "", value: "" })),
    };

    buttons.forEach((button, index) => {
      if (!button.label.trim()) {
        newErrors.buttons[index].label = "label is required .";
      }
      if (!button.value.trim()) {
        newErrors.buttons[index].value = "value is required .";
      }
    });

    setErrors(newErrors);

    if (
      !newErrors.banner_header_text &&
      newErrors?.buttons?.every((error) => !error.label && !error.value)
    ) {
      const payload = {
        code: headerText,
        params: buttons,
      };
      try {
        setLoader(true);
        const res = await callApi(`v1/content/new`, "post", {
          content: payload,
        });
        setLoader(false);
        if (res && res?.status === "Success") {
          showNotification("Content added successfully!", "success");

          navigate(CONTENT_LIST_ROUTE);
        } else {
          showNotification("Something went wrong. Please try again.", "error");
        }
      } catch (e) {
        showNotification("An error occurred . Please try again.", "error");
      }
    }
  };

  return (
    <>
      <BreadCrumb
        title={CONTENT_ADD_ROUTE}
        pageTitle={CONTENT_LIST_ROUTE}
        version="v1"
      />
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            {/* <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <div className="mb-4 xl:col-span-12"> */}
            <label className="inline-block mb-2 text-base font-medium">
              Code
            </label>
            <input
              type="text"
              className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="Enter Banner Header Text"
              value={headerText}
              onChange={(e) => {
                setErrors((prev) => ({
                  ...prev,
                  ["banner_header_text"]: "",
                }));
                setHeaderText(e.target.value);
              }}
            />
            {errors.banner_header_text && (
              <p className="text-red-500">{errors.banner_header_text}</p>
            )}

            {/* Add Button */}
            <div className="flex justify-end my-4">
              <button
                onClick={addButton}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add Code
              </button>
            </div>

            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              {/* Render Buttons */}
              {buttons?.map((button, index) => (
                <div key={index} className="py-4 xl:col-span-4">
                  <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
                    <label className="inline-block mb-2 text-base font-medium">
                      Label
                    </label>
                    <input
                      type="text"
                      value={button.label}
                      onChange={(e) =>
                        handleInputChange(index, "label", e.target.value)
                      }
                      className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Enter Label"
                    />
                    {errors.buttons[index]?.label && (
                      <p className="my-2 text-red-500">
                        {errors.buttons[index]?.label}
                      </p>
                    )}
                    <label className="inline-block mb-2 text-base font-medium">
                      Value
                    </label>
                    <input
                      type="text"
                      value={button.value}
                      onChange={(e) =>
                        handleInputChange(index, "value", e.target.value)
                      }
                      className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Enter Value"
                    />
                    {errors.buttons[index]?.value && (
                      <p className="my-2 text-red-500">
                        {errors.buttons[index]?.value}
                      </p>
                    )}
                    <div className="flex justify-end mt-2">
                      <button
                        onClick={() => removeButton(index)}
                        className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Save Button */}
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={() => handleSave()}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {loader ? <LoaderComponent /> : " Save"}
              </button>

              <Link
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                to={CONTENT_LIST_ROUTE}
              >
                cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddContent;
